var _rect, _rect2, _rect3, _rect4, _line, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _line2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 351,
    viewBox: "0 0 428 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 344,
    rx: 15.3957,
    fill: "url(#paint0_linear_132_14509)",
    fillOpacity: 0.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.384892,
    y: 0.384892,
    width: 427.23,
    height: 343.23,
    rx: 15.0108,
    stroke: "url(#paint1_linear_132_14509)",
    strokeOpacity: 0.08,
    strokeWidth: 0.769784
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 412,
    height: 342,
    rx: 9.23741,
    fill: "url(#paint2_linear_132_14509)",
    fillOpacity: 0.04
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.38489,
    y: 9.38489,
    width: 411.23,
    height: 341.23,
    rx: 8.85252,
    stroke: "url(#paint3_linear_132_14509)",
    strokeOpacity: 0.12,
    strokeWidth: 0.769784
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 152.802,
    y1: 7.69785,
    x2: 152.802,
    y2: 308.683,
    stroke: "url(#paint4_linear_132_14509)",
    strokeOpacity: 0.12,
    strokeWidth: 0.769784
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.1729,
    cy: 27.7122,
    r: 3.07914,
    fill: "white",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9493,
    cy: 27.7122,
    r: 3.07914,
    fill: "white",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.7266,
    cy: 27.7122,
    r: 3.07914,
    fill: "white",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0938,
    y: 64.6619,
    width: 110.849,
    height: 23.0935,
    rx: 6.15827,
    fill: "white",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 50.8058,
    width: 67.3831,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 64.6619,
    width: 53.9065,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 78.518,
    width: 41.6933,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 249.415,
    y: 50.8058,
    width: 29.9013,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 235.096,
    y: 64.6619,
    width: 24.0052,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 222.041,
    y: 78.518,
    width: 18.9515,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 283.527,
    y: 50.8058,
    width: 46.3259,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 262.47,
    y: 64.6619,
    width: 37.0607,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 243.519,
    y: 78.518,
    width: 28.6378,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 334.064,
    y: 50.8058,
    width: 16.8458,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 64.6619,
    width: 13.4766,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 274.684,
    y: 78.518,
    width: 10.5286,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 355.121,
    y: 50.8058,
    width: 32.8493,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 319.746,
    y: 64.6619,
    width: 26.5321,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 287.739,
    y: 78.518,
    width: 20.6361,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 103.921,
    width: 67.3831,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 117.777,
    width: 53.9065,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 249.415,
    y: 103.921,
    width: 29.9013,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 235.096,
    y: 117.777,
    width: 29.4801,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 283.527,
    y: 103.921,
    width: 33.2704,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 268.787,
    y: 117.777,
    width: 45.4836,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 320.167,
    y: 103.921,
    width: 11.792,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 318.482,
    y: 117.777,
    width: 16.8458,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 335.328,
    y: 103.921,
    width: 23.5841,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 339.118,
    y: 117.777,
    width: 32.8493,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.07
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 143.18,
    width: 67.3831,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 157.036,
    width: 53.9065,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 249.415,
    y: 143.18,
    width: 29.9013,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 235.096,
    y: 157.036,
    width: 24.0052,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 283.527,
    y: 143.18,
    width: 46.3259,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 262.47,
    y: 157.036,
    width: 37.0607,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 334.064,
    y: 143.18,
    width: 16.8458,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 157.036,
    width: 13.4766,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 355.121,
    y: 143.18,
    width: 32.8493,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 319.746,
    y: 157.036,
    width: 26.5321,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.03
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 182.439,
    width: 67.3831,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 177.82,
    y: 196.295,
    width: 53.9065,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 249.415,
    y: 182.439,
    width: 29.9013,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 235.096,
    y: 196.295,
    width: 24.0052,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 283.527,
    y: 182.439,
    width: 46.3259,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 262.47,
    y: 196.295,
    width: 37.0607,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 334.064,
    y: 182.439,
    width: 16.8458,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 196.295,
    width: 13.4766,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 355.121,
    y: 182.439,
    width: 32.8493,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 319.746,
    y: 196.295,
    width: 26.5321,
    height: 6.15827,
    rx: 3.07914,
    fill: "white",
    fillOpacity: 0.01
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0938,
    y: 96.9928,
    width: 110.849,
    height: 23.0935,
    rx: 6.15827,
    fill: "white",
    fillOpacity: 0.08
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0938,
    y: 129.324,
    width: 110.849,
    height: 23.0935,
    rx: 6.15827,
    fill: "white",
    fillOpacity: 0.06
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0938,
    y: 161.655,
    width: 110.849,
    height: 23.0935,
    rx: 6.15827,
    fill: "white",
    fillOpacity: 0.04
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0938,
    y: 193.986,
    width: 110.849,
    height: 23.0935,
    rx: 6.15827,
    fill: "white",
    fillOpacity: 0.02
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0938,
    y: 226.317,
    width: 110.849,
    height: 23.0935,
    rx: 6.15827,
    fill: "white",
    fillOpacity: 0.01
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0938,
    y: 258.647,
    width: 110.849,
    height: 23.0935,
    rx: 6.15827,
    fill: "url(#paint5_linear_132_14509)",
    fillOpacity: 0.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.69824,
    y1: 45.8022,
    x2: 152.418,
    y2: 45.8022,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 0.769784
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_132_14509",
    x1: 214,
    y1: 0,
    x2: 214,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_132_14509",
    x1: 214,
    y1: 0,
    x2: 214,
    y2: 360.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_132_14509",
    x1: 214,
    y1: 9,
    x2: 214,
    y2: 351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_132_14509",
    x1: 214,
    y1: 9,
    x2: 214,
    y2: 351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_132_14509",
    x1: 152.417,
    y1: 308.683,
    x2: 152.417,
    y2: 7.69785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_132_14509",
    x1: 78.5182,
    y1: 258.647,
    x2: 78.5182,
    y2: 281.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigin);
export default __webpack_public_path__ + "static/media/sigin.64019536e194e5a4406075921ba6c332.svg";
export { ForwardRef as ReactComponent };